import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20beautiful%20warm%20toned%20abstract%20illustration%20with%20soft%20gradients%20of%20peach%20pink%20and%20cream%20colors%20flowing%20organic%20shapes%20reminiscent%20of%20manga%20panel%20layouts%20and%20speech%20bubbles%20blending%20subtly%20artistic%20and%20modern%20with%20clean%20minimal%20aesthetic%20gentle%20warm%20atmosphere&width=1920&height=800&seq=hero-bg-manga-01&orientation=landscape"
        alt="43423漫画网 - 免费高清漫画在线阅读"
        title="43423漫画网 - 家教老师漫画免费阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <h1 className="text-2xl md:text-4xl font-bold text-background-50 text-center max-w-2xl" style={{ fontFamily: 'var(--font-heading)' }}>
          <strong>家教老师漫画</strong> - 免费阅读下拉式漫画
        </h1>
        <p className="mt-3 md:mt-4 text-sm md:text-base text-background-50/80 text-center max-w-xl">
          在<strong>43423漫画网</strong>免费在线阅读高清<strong>下拉式漫画</strong>，无需下载注册，畅享流畅阅读体验
        </p>

        <div className="mt-6 md:mt-8 flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
          <div className="relative w-full">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-foreground-400"></i>
            </span>
            <input
              type="text"
              placeholder="搜索你喜欢的漫画..."
              className="w-full pl-10 pr-4 py-3 text-sm rounded-full bg-background-50/95 border border-background-200/40 text-foreground-700 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
            />
          </div>
          <Link
            to="/category/rexue"
            className="w-full sm:w-auto px-6 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap text-center cursor-pointer"
          >
            开始阅读
          </Link>
        </div>

        <div className="mt-5 md:mt-6 flex items-center gap-4 md:gap-6">
          <div className="text-center">
            <p className="text-lg md:text-xl font-bold text-background-50">2000+</p>
            <p className="text-xs text-background-50/70">漫画作品</p>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="text-center">
            <p className="text-lg md:text-xl font-bold text-background-50">50万+</p>
            <p className="text-xs text-background-50/70">每日读者</p>
          </div>
          <div className="w-px h-8 bg-background-50/30"></div>
          <div className="text-center">
            <p className="text-lg md:text-xl font-bold text-background-50">10万+</p>
            <p className="text-xs text-background-50/70">章节更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}